/**
 * Построчный diff двух текстов — «что изменит правка ассистента».
 *
 * Сервер отдаёт новую версию протокола целиком (bit-llm-summarize, mode=edit),
 * а человеку перед «Применить» нужно увидеть только разницу: макет «Бумага»
 * рисует убранные строки зачёркнутыми, добавленные — подсвеченными.
 *
 * LCS по строкам: протоколы короткие (сотни строк), квадратичная таблица
 * дешевле любой библиотеки. Пустые строки в сравнении не участвуют — перенос
 * абзаца правкой не считается.
 */

function lines(text) {
  return String(text || '').split('\n').map((l) => l.trimEnd()).filter((l) => l.trim() !== '');
}

/** [{ k: ' ' | '-' | '+', t }] в порядке следования. */
export function lineDiff(before, after) {
  const a = lines(before);
  const b = lines(after);
  const n = a.length;
  const m = b.length;
  // dp[i][j] — длина LCS хвостов a[i:], b[j:]
  const dp = Array.from({ length: n + 1 }, () => new Array(m + 1).fill(0));
  for (let i = n - 1; i >= 0; i -= 1) {
    for (let j = m - 1; j >= 0; j -= 1) {
      dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
    }
  }
  const out = [];
  let i = 0;
  let j = 0;
  while (i < n && j < m) {
    if (a[i] === b[j]) { out.push({ k: ' ', t: a[i] }); i += 1; j += 1; }
    else if (dp[i + 1][j] >= dp[i][j + 1]) { out.push({ k: '-', t: a[i] }); i += 1; }
    else { out.push({ k: '+', t: b[j] }); j += 1; }
  }
  while (i < n) { out.push({ k: '-', t: a[i] }); i += 1; }
  while (j < m) { out.push({ k: '+', t: b[j] }); j += 1; }
  return out;
}

/** Только изменённые строки — то, что показываем в реплике. */
export function changedLines(before, after) {
  return lineDiff(before, after).filter((d) => d.k !== ' ');
}
